import React from 'react';
import { LocationOn, Phone, Email, Schedule } from '@mui/icons-material';

const Contact = () => {
  return (
    <section id="contact" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">Contact Us</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Get in touch with us for any inquiries about admissions, programs, or general information</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16">
          <div>
            <h3 className="text-blue-800 text-2xl font-semibold mb-8">Get in Touch</h3>
            <div className="flex flex-col gap-8">
              <div className="flex items-start gap-4">
                <div className="text-2xl text-blue-700"><LocationOn style={{ fontSize: '2rem', color: '#4A90E2' }} /></div>
                <div>
                  <h4 className="text-blue-800 font-semibold mb-1">Address</h4>
                  <p className="text-gray-600">123 Education Street<br />Pune City, IN 411058<br />India</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="text-2xl text-blue-700"><Phone style={{ fontSize: '2rem', color: '#4A90E2' }} /></div>
                <div>
                  <h4 className="text-blue-800 font-semibold mb-1">Phone</h4>
                  <p className="text-gray-600">+91 83590 87358<br />+91 77738 88992</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="text-2xl text-blue-700"><Email style={{ fontSize: '2rem', color: '#4A90E2' }} /></div>
                <div>
                  <h4 className="text-blue-800 font-semibold mb-1">Email</h4>
                  <p className="text-gray-600">rohanrathi.dev@gmail.com<br />rohanrathi.work@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="text-2xl text-blue-700"><Schedule style={{ fontSize: '2rem', color: '#4A90E2' }} /></div>
                <div>
                  <h4 className="text-blue-800 font-semibold mb-1">Office Hours</h4>
                  <p className="text-gray-600">Monday - Friday: 8:00 AM - 4:00 PM<br />Saturday: 9:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-md p-10">
            <h3 className="text-blue-800 text-2xl font-semibold mb-8">Send us a Message</h3>
            <form className="flex flex-col gap-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label htmlFor="firstName" className="text-blue-900 font-medium mb-2">First Name *</label>
                  <input type="text" id="firstName" name="firstName" required className="px-4 py-3 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-blue-800" />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="lastName" className="text-blue-900 font-medium mb-2">Last Name *</label>
                  <input type="text" id="lastName" name="lastName" required className="px-4 py-3 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-blue-800" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label htmlFor="email" className="text-blue-900 font-medium mb-2">Email Address *</label>
                  <input type="email" id="email" name="email" required className="px-4 py-3 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-blue-800" />
                </div>
                <div className="flex flex-col">
                  <label htmlFor="phone" className="text-blue-900 font-medium mb-2">Phone Number</label>
                  <input type="tel" id="phone" name="phone" className="px-4 py-3 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-blue-800" />
                </div>
              </div>
              <div className="flex flex-col">
                <label htmlFor="subject" className="text-blue-900 font-medium mb-2">Subject *</label>
                <select id="subject" name="subject" required className="px-4 py-3 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-blue-800">
                  <option value="">Select a subject</option>
                  <option value="admissions">Admissions Inquiry</option>
                  <option value="general">General Information</option>
                  <option value="campus-visit">Campus Visit</option>
                  <option value="academics">Academic Programs</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="flex flex-col">
                <label htmlFor="message" className="text-blue-900 font-medium mb-2">Message *</label>
                <textarea id="message" name="message" rows="5" required className="px-4 py-3 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-blue-800 resize-vertical min-h-[120px]" placeholder="Please provide details about your inquiry..."></textarea>
              </div>
              <button type="submit" className="inline-block px-8 py-3 rounded-lg font-medium text-white bg-blue-800 hover:bg-blue-900 transition-all text-lg shadow-lg">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 